import { z } from "zod";

export const periodDynamicYearNodeSchema = z.object({
  type: z.literal("year"),
  dynamic: z.literal(true),
});

export const periodOlderNodeSchema = z.object({
  id: z.string().min(1),
  label: z.string().min(1),
  type: z.literal("older"),
});

export const periodTreeNodeSchema = z.discriminatedUnion("type", [
  periodDynamicYearNodeSchema,
  periodOlderNodeSchema,
]);

export const periodsConfigSchema = z.object({
  minYear: z.number().int().nullable().optional(),
  tree: z.array(periodTreeNodeSchema).min(1),
});

export type PeriodsConfig = z.infer<typeof periodsConfigSchema>;
export type PeriodTreeNodeConfig = z.infer<typeof periodTreeNodeSchema>;
